import React, { PureComponent, ComponentType, ComponentClass } from 'react';
import throttle from 'lodash.throttle';

const LIMITS = {
  xsMob: 480,
  xs: 768,
  sm: 992,
  md: 1200,
};

const VIEWPORTS = {
  mobile: 'mobile',
  desktop: 'desktop',
  tablet: 'tablet',
};

export interface MobileWrapperState {
  isMobile: boolean;
  viewport: string;
}

function MobileWrapper(limit: 'xs' | 'md' | 'sm' | 'xsMob' = 'xs') {
  return function <T>(ComposedComponent: ComponentType<T & MobileWrapperState>): ComponentClass<Exclude<T, MobileWrapperState>> {
    return class IsMobileComponent extends PureComponent<Exclude<T, MobileWrapperState>, MobileWrapperState> {
      constructor(props) {
        super(props);
        this.state = {
          isMobile: window.innerWidth < LIMITS[limit],
          viewport: this.getViewport(),
        };
      }

      onResizeThrottled = null;

      onResize = () => {
        this.setState({
          isMobile: window.innerWidth < LIMITS[limit],
          viewport: this.getViewport(),
        });
      };

      getViewport() {
        if (window.innerWidth < LIMITS['xs']) {
          return VIEWPORTS.mobile;
        }
        if (window.innerWidth >= LIMITS['xs'] && window.innerWidth < LIMITS['md']) {
          return VIEWPORTS.tablet;
        }
        return VIEWPORTS.desktop;
      }

      componentDidMount() {
        this.onResizeThrottled = throttle(this.onResize, 10);
        window.addEventListener('resize', this.onResizeThrottled);
      }

      componentWillUnmount() {
        this.onResizeThrottled.cancel();
        window.removeEventListener('resize', this.onResizeThrottled);
      }

      render() {
        return (<ComposedComponent {...this.props} isMobile={this.state.isMobile} viewport={this.state.viewport}/>);
      }
    };
  };
}

export default MobileWrapper;
